import { render, staticRenderFns } from "./ShapeSelector.vue?vue&type=template&id=0001d4f6"
import script from "./ShapeSelector.vue?vue&type=script&lang=js"
export * from "./ShapeSelector.vue?vue&type=script&lang=js"
import style0 from "./ShapeSelector.vue?vue&type=style&index=0&id=0001d4f6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports